// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("./static/Quicksand-Light.ttf");
var ___CSS_LOADER_URL_IMPORT_1___ = require("./static/Quicksand-Regular.ttf");
var ___CSS_LOADER_URL_IMPORT_2___ = require("./static/Quicksand-Medium.ttf");
var ___CSS_LOADER_URL_IMPORT_3___ = require("./static/Quicksand-SemiBold.ttf");
var ___CSS_LOADER_URL_IMPORT_4___ = require("./static/Quicksand-Bold.ttf");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
   font-family: 'Quicksand';
   font-weight: 300;
   font-style: normal;
   src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
   font-display: swap;
}

@font-face {
   font-family: 'Quicksand';
   font-weight: 400;
   font-style: normal;
   src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
   font-display: swap;
}

@font-face {
   font-family: 'Quicksand';
   font-weight: 500;
   font-style: normal;
   src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
   font-display: swap;
}

@font-face {
   font-family: 'Quicksand';
   font-weight: 600;
   font-style: normal;
   src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
   font-display: swap;
}

@font-face {
   font-family: 'Quicksand';
   font-weight: 700;
   font-style: normal;
   src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
   font-display: swap;
}
`, "",{"version":3,"sources":["webpack://./src/css/fonts/Quicksand/styles.css"],"names":[],"mappings":"AAAA;GACG,wBAAwB;GACxB,gBAAgB;GAChB,kBAAkB;GAClB,4CAAwC;GACxC,kBAAkB;AACrB;;AAEA;GACG,wBAAwB;GACxB,gBAAgB;GAChB,kBAAkB;GAClB,4CAA0C;GAC1C,kBAAkB;AACrB;;AAEA;GACG,wBAAwB;GACxB,gBAAgB;GAChB,kBAAkB;GAClB,4CAAyC;GACzC,kBAAkB;AACrB;;AAEA;GACG,wBAAwB;GACxB,gBAAgB;GAChB,kBAAkB;GAClB,4CAA2C;GAC3C,kBAAkB;AACrB;;AAEA;GACG,wBAAwB;GACxB,gBAAgB;GAChB,kBAAkB;GAClB,4CAAuC;GACvC,kBAAkB;AACrB","sourcesContent":["@font-face {\r\n   font-family: 'Quicksand';\r\n   font-weight: 300;\r\n   font-style: normal;\r\n   src: url('./static/Quicksand-Light.ttf');\r\n   font-display: swap;\r\n}\r\n\r\n@font-face {\r\n   font-family: 'Quicksand';\r\n   font-weight: 400;\r\n   font-style: normal;\r\n   src: url('./static/Quicksand-Regular.ttf');\r\n   font-display: swap;\r\n}\r\n\r\n@font-face {\r\n   font-family: 'Quicksand';\r\n   font-weight: 500;\r\n   font-style: normal;\r\n   src: url('./static/Quicksand-Medium.ttf');\r\n   font-display: swap;\r\n}\r\n\r\n@font-face {\r\n   font-family: 'Quicksand';\r\n   font-weight: 600;\r\n   font-style: normal;\r\n   src: url('./static/Quicksand-SemiBold.ttf');\r\n   font-display: swap;\r\n}\r\n\r\n@font-face {\r\n   font-family: 'Quicksand';\r\n   font-weight: 700;\r\n   font-style: normal;\r\n   src: url('./static/Quicksand-Bold.ttf');\r\n   font-display: swap;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
